import { CsiHttp } from './../../core/csi-http';
import { environment } from './../../../environments/environment';
import { Injectable } from '@angular/core';

@Injectable()
export class LogService {

  api = environment.principal;

  constructor(private http: CsiHttp) { }


  criaRegistroLog(nmAbrevUsuario: string, cdFuncao: String, tpFuncao: string, idProcesso: number, dsComplemento: string) {
    const url = this.api + '/criaRegistroLog';
    return this.http.postIgnore(url,
          {nmAbrevUsuario: nmAbrevUsuario, cdFuncao: cdFuncao,
            tpFuncao: tpFuncao, idProcesso: idProcesso, dsComplemento: dsComplemento}).map(
      resposta => {
        return resposta;
      }
    );
  }

  inserirLog(cdProcesso, tpProcesso, idChave, dsChave, dsComplemento, flString) {
    const url = this.api + '/inserirLog';
    return this.http.postIgnore(url,
          {cdProcesso: cdProcesso, tpProcesso: tpProcesso,
            idChaveN: idChave, idChaveS: idChave, dsChave: dsChave, dsComplemento: dsComplemento, flString: flString}).map(
      resposta => {
        return resposta;
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/commons/servicos/log.service.ts